const fileApisSupported =
  // @ts-ignore
  window.File && window.FileReader && window.FileList && window.Blob;

export { fileApisSupported };

export async function fileAsText(input: HTMLInputElement): Promise<string> {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject("Problem reading file from input element.");
    };

    reader.onload = () => {
      resolve(reader.result as string);
    };

    if (!input.files || input.files.length !== 1) {
      reject("Input files were not valid.");
    } else {
      reader.readAsText(input.files[0]);
    }
  });
}
